import React, { useState, useEffect } from 'react';
import { Modal } from 'antd';
import '../../assets/enhancePack.scss';
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector } from 'react-redux';
import action from '../../views/account/redux/action';
import { requestPurchaseUrl } from '@/views/account/api/apiHistory';
import utils from '../../utils/utils';
import myUtil from '../../utils/index';
import cartUrl from '@/views/account/utils/cartUrl';
import {
  requsetGetSubscription,
  requsetGetAllSubscription,
} from '@/views/account/api/apis';
const EnhancerPack = () => {
  const [select, setSelect] = useState(0);
  const [urlParam, setUrlParam] = useState('');
  const { t } = useTranslation('toolsPurchaseVideoEnhancer');
  const dispatch = useDispatch();
  const reduceData = useSelector((state) => state.account.openPack);
  const enhanceVideoPackData = [
    { flow: '600MB', price: t('WeekTotalPrice'), pack: 600 },
    { flow: '3000MB', price: t('MonthTotalPrice'), pack: 3000 },
    { flow: '40000MB', price: t('YearTotalPrice'), pack: 4000 },
  ];

  useEffect(() => {
    if (window.location.href.indexOf('track[type]') >= 0) {
      // eslint-disable-next-line no-restricted-globals
      const urlParam = myUtil.getUrlParam(location.href);
      setUrlParam(urlParam);
    } else {
      const track = cartUrl('');
      let obj = {};
      Object.keys(track).map((v) => {
        const objName = `track[${v}]`;
        obj[objName] = `${track[v]}`;
      });
      setUrlParam(obj);
    }
  }, []);

  const openPurchase = () => {
    let newParam = { ...urlParam };
    newParam['track[reason]'] = '17';
    newParam['track[func]'] = '39';
    let cycle = '';
    if (select === 0) {
      cycle = `4`;
    } else if (select === 1) {
      cycle = `5`;
    } else {
      cycle = `6`;
    }
    let str = `plan=${
      enhanceVideoPackData[select].pack
    }&site=${utils.getLanguage()}`;
    requestPurchaseUrl('video-enhancer-checkout' + '?' + str).then((res) => {
      let url =
        res.data.cart_url +
        `&track[type]=${newParam['track[type]']}&track[sid]=${newParam['track[sid]']}&track[func]=${newParam['track[func]']}&track[reason]=${newParam['track[reason]']}&track[host]=${newParam['track[host]']}&track[platform]=${newParam['track[platform]']}&track[cycle]=${cycle}&track[ab]=${newParam['track[ab]']}&track[channel]=${newParam['track[channel]']}&track[discount]=${newParam['track[discount]']}`;
      window.open(url);
    });
  };

  const changeSelect = (value) => {
    setSelect(value);
  };
  console.log(reduceData);
  const closeModal = () => {
    dispatch(
      action.onOpenPack({
        open: false,
        type: '',
      })
    );
    requsetGetSubscription()
      .then((res) => {
        console.log(res);
        if (res.code === 200) {
          console.log('res---------------', res);
          dispatch(action.onSubscriptionChange(res.data.subscription));
        }
      })
      .catch((err) => {
        console.log(err);
      });
    requsetGetAllSubscription().then((res) => {
      console.log(res);
      if (res.code === 200) {
        console.log('allRes..............', res);
        dispatch(action.getAllSubscription(res.data.subscription));
      }
    });
  };
  return (
    <div>
      <Modal
        centered
        width={500}
        className='enhancePack'
        visible={reduceData.open}
        footer={null}
        maskClosable={false}
        onCancel={closeModal}
      >
        <div className='title'>Extend More Processing Volume For</div>
        <div className='subTitle'>
          <div>
            {reduceData.type === 'videoEnhancer'
              ? t('toolsPurchaseVideoEnhancer:HitPawOnlineAIVideoEnhance')
              : t('toolsPurchasePhotoEnhancer:HitPawAIPhotoEnhancer')}
          </div>
          <div className='pro'>Pro</div>
        </div>
        <div className='buyItem'>
          {enhanceVideoPackData.map((item, value) => {
            return (
              <div
                key={value}
                onClick={() => changeSelect(value)}
                className={`addItem ${select === value ? 'selected' : ''}`}
              >
                <div>{item.flow}</div>
                <div>{item.price}</div>
              </div>
            );
          })}
        </div>
        <div
          onClick={() => {
            openPurchase();
          }}
          className='buyNow'
        >
          {t('purchase:buyBtn')}
        </div>
      </Modal>
    </div>
  );
};

export default EnhancerPack;
